import React from 'react';
import PropTypes from 'prop-types';
import { Profile } from 'api/api-profile';
import { FormBuilder } from '../forms/form';
import get from "lodash/get";
import { FormattedMessage, injectIntl } from "react-intl";

class VerificationForm extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      errorMsg: null
    };
    this.verificationAction = this.verificationAction.bind(this);
    this.verificationCb = this.verificationCb.bind(this);
    this.sendCodeAction = this.sendCodeAction.bind(this);
    this.sendCodeCb = this.sendCodeCb.bind(this);
  }

  // == Start of signup form
  componentWillMount () {
    this.sendCodeAction();
  }

  sendCodeAction (clickResend) {
    const accessToken = PSSessions.Cookies('PSAccess');
    const path = '/v1/profiles/me/email/verify';
    Profile.read(path, accessToken, this.sendCodeCb.bind(this, clickResend));
    if (clickResend) {
      analyticsIntegrations.resendVerification();
    }
  }

  sendCodeCb (clickResend, response) {
    if (response.error) {
      let errorMsg = response.error_description;
      if (400 < response.statusCode || 'Invalid JSON' === errorMsg) {
        errorMsg = 'An unexpected error occurred. Please try again in a few minutes.';
      }
      this.setState({ errorMsg });
    } else {
      if (clickResend) {
        this.props.verificationFooter();
      }
    }
  }

  verificationAction (formElement, callback,refs) {
    const accessToken = PSSessions.Cookies('PSAccess');
    const path = 'me/email/verify';
    const verificationCodeInput = get(refs, 'verificationCode');
    const profileBody = {};
    profileBody.email_verification_code = verificationCodeInput.getValue();
    Profile.update(path, accessToken, profileBody, callback);
  }

  verificationCb (response) {
    if (response.error) {
      let errorMsg = 'The verification code is incorrect.';
      if (400 < response.statusCode) {
        errorMsg = 'An unexpected error occurred. Please try again in a few minutes.';
      }
      this.setState({ errorMsg });
    } else {
      this.props.callbackFn();
    }
  }

  render () {
    const verificationFormInputMetaData = [{
      inputFieldName: 'verification_code',
      elementID: 'verification_code',
      optional: false,
      ref: 'verificationCode',
      hideRequired: true,
      colSize: 'col-xs-12'
    }];

    return (
      <div>
        <FormBuilder
          ref="verificationForm"
          formname="verification form"
          formStyle="standard"
          errorText={this.state.errorMsg}
          formInputs={verificationFormInputMetaData}
          submitAction={this.verificationAction}
          submitCallback={this.verificationCb}
          isButtonDisabled={false}
          buttonText={this.props.intl.formatMessage({ id: 'shared_components.verify_email.check_email_button', defaultMessage: 'Verify' })}
        />
        <div className="text-center">
          <p className="text-center text-small text-gray-600 margin-lg-top">
            <FormattedMessage
              id='shared_components.verify_email.didnt_get_email'
              defaultMessage='Didn’t get an email? It can take a few minutes, but also check your Spam and Promotions folder.'
            />           
          </p>
          <button className="btn btn-link no-gutter remove-click-styling" onClick={() => this.sendCodeAction(true)} >
            <FormattedMessage
              defaultMessage='Resend code'
              id='shared_components.verify_email.resend_code'
            />
          </button>
        </div>
      </div>
    );
  }
}

VerificationForm.propTypes = {
  callbackFn: PropTypes.func,
  verificationFooter: PropTypes.func
};

exports.VerificationForm = injectIntl(VerificationForm);
